<template>
    <tr>
        <td>
            <span v-if="edit">
                <b-form-input
                    type="text"
                    v-model="form.name"
                    placeholder="Nombre de la compañía"
                    class="border"
                    style=""
                >
                </b-form-input>
            </span>
            <span v-else>
                {{row.name}}
            </span>
        <td>{{ row.id }}</td>
        <td>{{ this.$moment(row.created).format("DD/MM/YYYY HH:MM") }}</td>
        <td>{{ this.$moment(row.updated).format("DD/MM/YYYY HH:MM") }}</td>
        <td>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="editRow"
                v-if="!edit"
            >
                <i class="text-center fa fa-wrench fa-fw"></i>
                Editar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="saveChanges"
                v-if="edit"
            >
                <i class="text-center fa fa-save fa-fw"></i>
                Guardar
            </b-button>
            <b-button
                class="border mr-2"
                size="sm"
                variant="light"
                @click="deleteRow"
            >
                <i class="text-center fa fa-trash fa-fw"></i>
                Eliminar
            </b-button>
        </td>
    </tr>
</template>


<script>
/* eslint-disable */
export default {
    componenents: {},
    props: {
        row: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            edit: false,
            form: {
                name: this.row != null ? this.row.name : ''
            },
        }
    },
    methods: {
        async editRow()  {
            this.edit = true
            
        },
        async saveChanges() {
            this.edit = false
            const data = {
                item_id: this.row.id,
                payload: {
                    ...this.form
                }
            }
            await this.$store.dispatch('buscompanies/updateBusCompany', data)
            this.$notify({
                group: "foo",
                title: "Compañía de bus editada",
                text: "Se ha editado la información de la compañía de bus",
                type: "success",
            });
        },
        async deleteRow() {
            const data = {
                item_id: this.row.id,
            }
            this.$store.dispatch('buscompanies/deleteBusCompany', data)
            .then( response => {
                this.$store.dispatch('buscompanies/retrieveBusCompanies')
                this.$notify({
                    group: "foo",
                    title: "La compañía de bus se ha eliminado",
                    text: "La compañía de bus " + this.row.name + " se ha eliminado satisfactoriamente",
                    type: "success",
                });
            })
            .catch( error => {
                this.$notify({
                    group: "foo",
                    title: "La compañía de bus no se puede eliminar",
                    text: "La compañía de bus " + this.row.name + " no se puede eliminar",
                    type: "error",
                });
            })
        }
    },
}
</script>
